import React from "react";
import { css } from "@emotion/react";
import {
  Label,
  Font,
  Icon,
  TextLink,
} from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { corporateNumberValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  name: string;
  labelRequired: boolean;
};

const corporateNumberFormField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          法人番号 {props.labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <div css={textFieldWrapper}>
          <FormTextField
            name={props.name}
            registerOptions={{
              validate: corporateNumberValidation,
            }}
            maxLength={13}
            ref={ref}
          />
          <FormErrorMessage name={props.name} />
        </div>
        <div css={{ marginLeft: 16 }}>
          <TextLink target="_blank" href="https://www.houjin-bangou.nta.go.jp/">
            <span css={{ display: "flex", alignItems: "center" }}>
              <span css={{ marginRight: 8 }}>法人番号検索サイト</span>
              <Icon name="openInNew" size="sm" css={{ cursor: "pointer" }} />
            </span>
          </TextLink>
        </div>
      </div>
    </div>
  );
};

export const CorporateNumberFormField = React.forwardRef(
  corporateNumberFormField
);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  display: "flex",
  alignItems: "center",
});

const textFieldWrapper = css({
  width: "196px",
});
